import { useState } from 'react';
import { createContainer } from 'unstated-next';

const notificationInitialState = {
  type: null,
  messageComponent: null,
  timeout: 0,
  isOpen: false,
};
const initialState = {
  isLoaded: false,
  notification: notificationInitialState,
};

export function useApplicationHook(stateParam) {
  const combinedState = {
    ...initialState,
    ...stateParam,
  };
  const [state, updateApplicationData] = useState(combinedState);
  const setApplicationLoaded = status =>
    updateApplicationData({
      ...state,
      isLoaded: status,
    });

  const setNotification = notification => {
    updateApplicationData({
      ...state,
      notification: {
        timeout: 3000,
        ...notification,
        isOpen: true,
      },
    });
  };

  const clearNotification = () =>
    updateApplicationData({
      ...state,
      notification: {
        ...state.notification,
        isOpen: false,
      },
    });

  return { state, setApplicationLoaded, setNotification, clearNotification };
}

const ApplicationContainer = createContainer(useApplicationHook);

export default ApplicationContainer;
